import { Authorization } from '@/utils/authorization'

export function logoutOnAll() {
  Authorization.clear.accessToken()
  //Clear the localStorage
  localStorage.clear()
  window.location.href = '/login'
}
